import axiosInstance from "../api/axiosInstance";
import API_ENDPOINTS from "../api/endpoints";

const FormulaService = {
  getAllFormulas: (params) => axiosInstance.get(API_ENDPOINTS.FORMULA.GET_ALL_FORMULAS, {
    params: params,
  }),
  getFormulaById: (id) => axiosInstance.get(API_ENDPOINTS.FORMULA.GET_BY_ID(id)),
  createFormula: (data) => axiosInstance.post(API_ENDPOINTS.FORMULA.CREATE_FORMULA, data),
  updateFormula: (id, data) => axiosInstance.put(API_ENDPOINTS.FORMULA.UPDATE_FORMULA(id), data),
  deleteFormula: (id) => axiosInstance.delete(API_ENDPOINTS.FORMULA.DELETE_FORMULA(id)),
};

export default FormulaService;
